import styled from '@emotion/styled'
import MuiDialogActions from '@mui/material/DialogActions'
import MuiInput from '@mui/material/Input'

import { DialogContent } from '@shared/ui/dialogs'

export const Field = styled.div`
  width: 100%;
`

export const ProgressContainer = styled.div`
  height: 4px;
`

export const Title = styled.h2`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 0 0 6px 0;

  color: ${({ theme }) => theme.colors.textPrimaryBlue};
  font-size: 16px;
  font-weight: 500;
`

export const ErrorMessage = styled.p`
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.radicalRed};
`

export const TextareaTitle = styled.h4`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 24px 0 20px 0;

  color: ${({ theme }) => theme.colors.textPrimaryBlue};
  font-size: 14px;
  font-weight: 500;
`

export const Container = styled(DialogContent)`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.textSecondBlue};

  & .MuiFormControlLabel-label {
    font-size: 14px;
  }

  & .MuiInputBase-input::placeholder {
    font-size: 14px;
  }
`

export const Input = styled(MuiInput)`
  &.MuiInput-root {
    /* 為了視覺對齊增加的間距 */
    margin-right: 16px;
  }

  > .MuiInput-input {
    font-size: 14px;

    &::placeholder {
      color: ${({ theme }) => theme.colors.textSecondBlue};
      opacity: 1;
    }
  }
`

export const DialogActions = styled(MuiDialogActions)`
  &.MuiDialogActions-root {
    padding: 0 20px 16px 20px;
  }
`

export const ImportExampleDialogActions = styled(MuiDialogActions)`
  &.MuiDialogActions-root {
    padding: 20px 0px 16px 20px;
  }
`
